import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const ArrowLink = props => {
    const rootClasses = classNames("arrow-link", props.ClassName, {
        [`${props.CtaTextColorClass}--text`]: props.CtaTextColorClass
    });

    return <div className={rootClasses} dangerouslySetInnerHTML={{ __html: props.CtaLink }} />;
};

ArrowLink.propTypes = {
    ClassName: PropTypes.string,
    CtaLink: PropTypes.string,
    CtaTextColorClass: PropTypes.string
};

export default ArrowLink;
